import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'

import questionMark from '../../styles/assets/tableIcons/question-default.svg'
import questionMark2 from '../../styles/assets/tableIcons/question-clear.svg'
import { fonts } from '../../styles/variables'

const viewportTooltipWidthBreakpoints = {
  xs: {
    maxWidth: '150px',
    minWidth: '150px',
  },
  sm: {
    maxWidth: '205px',
    minWidth: '180px',
  },
  lg: {
    maxWidth: '250px',
    minWidth: '200px',
  },
}

const getTooltipWidthFromInnerWidth = () => {
  const width = window.innerWidth

  if (width < 600) return viewportTooltipWidthBreakpoints.xs
  return viewportTooltipWidthBreakpoints.lg
}

const QuestionMark = styled.img((props) => ({
  display: 'inline-block',
  width: props.width || '14px',
  opacity: '0.5',
  cursor: 'pointer',
  verticalAlign: 'middle',
  ':hover': {
    opacity: '1',
  },
}))

export const TooltipText = styled.div((props) => ({
  fontFamily: fonts.primary,
  textAlign: 'left',
  fontSize: '13px',
  textTransform: 'none',
  whiteSpace: 'pre-wrap',
  zIndex: 99999,
  '& > b': {
    fontFamily: fonts.primaryBold,
  },
  ...getTooltipWidthFromInnerWidth(),
  ...props,
}))

export default ({
  text,
  clear,
  width,
  offset = 0,
  place = 'bottom',
  content,
  textStyle,
  elementRef,
  ...rest
}) => (
  <Tooltip
    arrow
    position={place}
    offset={offset}
    boundary="viewport"
    popperOptions={{
      modifiers: {
        preventOverflow: {
          enabled: false,
        },
        hide: {
          enabled: false,
        },
      },
    }}
    html={
      <TooltipText dangerouslySetInnerHTML={{ __html: text }} {...textStyle} />
    }
    {...rest}
  >
    {content || (
      <QuestionMark
        ref={elementRef}
        width={width}
        src={clear ? questionMark2 : questionMark}
      />
    )}
  </Tooltip>
)
